import $ from 'jquery';
let envParam = $.trim(process.env.REACT_APP_ENVIRONMENT);



export default env => {
	if (envParam === 'PROD') {
		return require('./config.prod');
	}
	else if (envParam === 'STAGING') {
		return require('./config.staging');
	}
	else {
		return require('./config.dev');
	}
}


// WEBPACK FOOTER //
// ./src/configs/config.js